import { calculateTotals } from "./production_costs/totals.js";

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("productionCostForm");
  if (!form) return;

  const productionCostId = form.dataset.productionCostId;
  console.log(productionCostId ? `Editing production cost ID: ${productionCostId}` : "Creating new production cost");

  // Recalculate totals on input change
  form.addEventListener("input", () => calculateTotals());

  // Initial calculation
  calculateTotals();
});
